import { Outlet } from 'react-router-dom'
import { AppShell } from '@/components/layout/app-shell'
import { Toaster } from '@/components/ui/sonner'
import { authClient } from '@/lib/auth-client'

export default function RootLayout() {
  const { data: session, isPending } = authClient.useSession()

  return (
    <AppShell
      session={session}
      isPending={isPending}
      onSignOut={() => {
        void authClient.signOut()
      }}
    >
      <Outlet />

      <Toaster position="top-right" richColors />
    </AppShell>
  )
}
